"use client";

import { oauthProviderClient } from "@better-auth/oauth-provider/client";
import { emailOTPClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";

const apiBaseURL = process.env.NEXT_PUBLIC_NEWFORM_API_DOMAIN;
if (process.env.NODE_ENV === "production" && !apiBaseURL)
  throw new Error(
    "NEXT_PUBLIC_NEWFORM_API_DOMAIN is required for creator sign-in",
  );

/**
 * Better Auth's base URL can't carry a path, so when the API sits behind this
 * app's own origin under a prefix (a personal staging slot, local proxying;
 * see next.config.mjs), Better Auth is reached at that origin's /api/auth.
 */
function sharedAuthBaseURL(apiDomain: string): string {
  const url = new URL(apiDomain);
  return url.pathname.replace(/\/$/, "") ? url.origin : apiDomain;
}

// Auth cookies belong to the API host.
export const sharedAuthClient = createAuthClient({
  baseURL: sharedAuthBaseURL(apiBaseURL ?? "http://localhost:3001"),
  basePath: "/api/auth",
  fetchOptions: { credentials: "include" },
  // oauthProviderClient carries a connector's signed authorization request
  // (the `sig` query on /sign-in and /oauth/consent) into sign-in and consent,
  // so Better Auth picks the connection up where it left off.
  plugins: [emailOTPClient(), oauthProviderClient()],
});
